import React from 'react';

interface IconProps {
    color?: string;  // Cor do ícone
    height?: string; // Altura do ícone
}

const CatalogIcon: React.FC<IconProps> = ({ color = "#000000", height = "24" }) => (
    <svg
        height={height}
        viewBox="0 0 32 32"
        width={height}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill={color}
            d="m26 2h-18a2 2 0 0 0 -2 2v4h-2v2h2v5h-2v2h2v5h-2v2h2v4a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-24a2 2 0 0 0 -2-2zm0 26h-18v-4h2v-2h-2v-5h2v-2h-2v-5h2v-2h-2v-4h18z"
        />
        <path
            fill={color}
            d="m14 8h8v2h-8z"
        />
        <path
            fill={color}
            d="m14 15h8v2h-8z"
        />
        <path
            fill={color}
            d="m14 22h8v2h-8z"
        />
        <path fill="none" d="m0 0h32v32h-32z" />
    </svg>
);

export default CatalogIcon;
